'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

require('react-s-alert/dist/s-alert-default.css');

require('react-s-alert/dist/s-alert-css-effects/slide.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AlertError: {
        displayName: 'AlertError'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/AlertError/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AlertError = _wrapComponent('AlertError')((_dec = (0, _reactRedux.connect)(function (state) {
    return { error: state.error };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(AlertError, _Component);

    function AlertError() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AlertError);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AlertError.__proto__ || (0, _getPrototypeOf2.default)(AlertError)).call.apply(_ref, [this].concat(args))), _this), _this.showAlert = function (isShowError, message) {
            // показ popup с ошибкой
            if (isShowError) {
                setTimeout(function () {
                    _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 5000 });
                }, 1000);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AlertError, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showAlert(this.props.error.show_error, this.props.error.message_error, this.props.error.error_code, this.props.error.error_title);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.showAlert(nextProps.error.show_error, nextProps.error.message_error, nextProps.error.error_code, nextProps.error.error_title);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react3.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } });
        }
    }]);
    return AlertError;
}(_react2.Component), _class2.propTypes = {
    error: _react2.PropTypes.object
}, _temp2)) || _class));

exports.default = AlertError;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlertError/index.jsx
// module id = 1599
// module chunks = 0